import { Box } from '@mui/material'

import { Flag } from '@/icons'

export function Violation() {
  return (
    <Box color="warning.main" width={12}>
      <Flag />
    </Box>
  )
}
